import { render, staticRenderFns } from "./PopupAddStockProduct.vue?vue&type=template&id=48c92427&"
import script from "./PopupAddStockProduct.vue?vue&type=script&lang=js&"
export * from "./PopupAddStockProduct.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddStockProduct.vue?vue&type=style&index=0&id=48c92427&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports